export default function CMultiLineComments() {
  return <h2>C Multi Line Comments</h2>;
}
